module.exports = "/dist/10f29d139edacde92df63374c5672568.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-600italic.woff2
// module id = 131
// module chunks = 0